import Backbone from 'backbone';
import ko from 'knockout';

import errorMessageTemplate from './error-message-template.pug';

export class ErrorMessageView extends Backbone.View {
  initialize({ errorMessage }) {
    this.errorMessage = errorMessage;
    this.viewModel = {
      showError: ko.observable(false),
    };
  }

  render() {
    this.$el.html(errorMessageTemplate({
      errorMessage: this.errorMessage,
    }));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  setVisibility(newVisibility) {
    this.viewModel.showError(newVisibility);
  }
}
